import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from './../shared/shared.module';

import { RaiseRiskComponent } from './components/raise-risk/raise-risk.component';
import { RiskRoutingModule } from './risk-routing.module';

import { RiskConstantsService } from './services/risk-constants.service';
import { RiskService } from './services/risk.service';
import { MyRiskDashboardComponent } from './components/my-risk-dashboard/my-risk-dashboard.component';
import { LineGraphComponent } from './components/line-graph/line-graph.component';
import { RaiseRiskMOCComponent } from './components/raise-risk-moc/raise-risk-moc.component';
import { RaiseRiskJSAComponent } from './components/raise-risk-jsa/raise-risk-jsa.component';
import { RaiseRiskHEMPComponent } from './components/raise-risk-hemp/raise-risk-hemp.component';
import { RaiseRiskHAZOPComponent } from './components/raise-risk-hazop/raise-risk-hazop.component';
import { RaiseRiskHAZIDComponent } from './components/raise-risk-hazid/raise-risk-hazid.component';
import { RiskPendingApprovalComponent } from './components/risk-pending-approval/risk-pending-approval.component';

@NgModule({
  imports: [
    CommonModule,
    RiskRoutingModule,
    SharedModule
  ],
  declarations:
  [
    RaiseRiskComponent,
    MyRiskDashboardComponent,
    LineGraphComponent,
    RaiseRiskMOCComponent,
    RaiseRiskJSAComponent,
    RaiseRiskHEMPComponent,
    RaiseRiskHAZOPComponent,
    RaiseRiskHAZIDComponent,
    RiskPendingApprovalComponent
  ],
  providers: [
    RiskService,
    RiskConstantsService
  ]
})
export class RiskModule { }
